import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    background-color: ${vars.backgroundMain};
    padding: 0 0 10em 0;

    .regulations {
        padding: 2em 0 0 0;

        .regulations-data {
            margin-top: 2em;
            padding: 3em 3em 6em 3em;
            background-color: ${vars.colorSecondary};
            border-radius: 0.3em;

            h1,
            h2,
            h3,
            p {
                color: ${vars.colorTextWhite};
            }

            .regulations-header {
                margin: 0 0 2em 0;

                .layout-button {
                    &.desktop {
                        display: flex;
                    }

                    &.mobile {
                        display: none;
                    }
                }

                .regulations-header-headline {
                    font-size: 3em;
                }

                .regulations-header-description {
                    font-size: 0.8em;
                }
            }

            .regulations-content {
                width: 100%;
                min-height: 1000px;
                height: 80vh;

                iframe {
                    border: none;
                    width: 100%;
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletL}) {
        .regulations {
            .regulations-data {
                padding: 3em;

                .regulations-header {
                    .layout-button {
                        &.desktop {
                            display: none;
                        }

                        &.mobile {
                            display: flex;
                        }
                    }

                    .regulations-header-headline {
                        margin-bottom: 1em;
                        text-align: center;
                        font-size: 1.9em;
                    }

                    .regulations-header-description {
                        font-size: 0.9em;
                    }
                }

                .regulations-content {
                    display: none;
                }
            }
        }
    }
`;
